module.exports = __webpack_public_path__ + "fonts/TTNormsPro-Light.0ec415bc.eot";